import { API_BASE, getToken } from "@/lib/api";

export const ADVISOR_PROMPTS = [
  "How is the business doing this week?",
  "Where are prospects dropping out of the funnel?",
  "Are Pro and Elite subscribers profitable after AI costs?",
  "How much AI are free users using, and should I tighten limits?",
  "Which leads should I contact today?",
  "Which email campaign is converting best?",
];

const parseEvent = (line) => {
  const raw = line.replace(/^data:\s?/, "");
  if (!raw || raw === "[DONE]") return null;
  try { return JSON.parse(raw); } catch { return { type: "delta", content: raw }; }
};

// POST /admin/advisor/chat: streams SSE ({type:'delta'|'done'|'error'}) or returns JSON {reply, session_id}.
export const askAdvisor = async ({ message, session_id }, onDelta) => {
  const res = await fetch(`${API_BASE}/admin/advisor/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}`, Accept: "text/event-stream" },
    body: JSON.stringify({ message, session_id: session_id || null }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(typeof body.detail === "string" ? body.detail : body.detail?.message || `Advisor error (${res.status})`);
    err.status = res.status;
    throw err;
  }
  if (!(res.headers.get("content-type") || "").includes("event-stream")) {
    const d = await res.json();
    onDelta(d.reply || d.message || d.content || "");
    return { session_id: d.session_id, title: d.title };
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "", meta = {};
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const ev = parseEvent(p.split("\n").filter((l) => l.startsWith("data:")).join("\n"));
      if (!ev) continue;
      if (ev.type === "error") throw new Error(ev.message || "Advisor error");
      if (ev.type === "done") meta = { session_id: ev.session_id, title: ev.title };
      else if (ev.content) onDelta(ev.content);
      if (ev.session_id && !meta.session_id) meta.session_id = ev.session_id;
    }
  }
  return meta;
};
